import React, { useState }                                                          from 'react';
import { KirokuCardBodyWeb, KirokuCardWeb, KirokuInputDate, KirokusSortableHandle } from '../../../ui';
import ActionGroupBtn                                                               from './ActionGroupBtn';
import QuestionCardTitle                                                            from './QuestionTitleCard';
import InfoQuestion                                                                 from './InfoQuestion';
import CheckboxUnrequited                                                           from './CheckboxUnrequited';
import NextQuestion                                                                 from './NextQuestion';
import moment                                                                       from 'moment';
import useQuestions                                                                 from '../MakeSurvey/useQuestions';
import { modalSetLogic }                                                            from '../ModalSetLogicByQuestionType';
import ModalEditQuestion
                                                                                    from '../FormQuestion/ModalEditQuestion';
import ComponentMobile                                                              from '../../../ui/ComponentMobile';
import KirokuInputDateMobile
                                                                                    from '../../../ui/KirokuInputDateMobile';
import ComponentWeb                                                                 from '../../../ui/ComponentWeb';
import { useTranslation }                                                           from 'react-i18next';

export default function OnlyDate({ question }) {
    const { update, copy, delQuestion }                         = useQuestions();
    const ModalSetLogic                                         = modalSetLogic[question.type];
    const [isOpenModalEditQuestion, setIsOpenModalEditQuestion] = useState(false);
    const [isOpenModalName, setIsOpenModalName]                 = useState(null);
    const { t }                                                 = useTranslation();
    return (
        <div id='component-question'>
            <div id='web-q' className='pb-3'>
                <KirokuCardWeb>
                    <KirokusSortableHandle>
                        <QuestionCardTitle
                            index={question.index}
                            isLogic={typeof question.nextQuestion === 'number'}
                        >
                            <ActionGroupBtn
                                handleOpenModalAddLogic={() => {
                                    setIsOpenModalName(question.index);
                                }}
                                handleOpenModalEdit={() => {
                                    setIsOpenModalEditQuestion(true);
                                }}
                                question={question}
                                resetDefaultAnswer={() => {
                                    if (question.defaultAnswer !== undefined) {
                                        delete question.defaultAnswer;
                                        update(question);
                                    }
                                }}
                                handleDel={() => delQuestion(question.index)}
                                handleCopy={() => {
                                    copy(question);
                                }}
                            />
                        </QuestionCardTitle>
                    </KirokusSortableHandle>
                    <KirokuCardBodyWeb>
                        <CheckboxUnrequited
                            question={question}
                            isNotUse={typeof question.nextQuestion === 'number'}
                        />
                        <InfoQuestion question={question}/>
                        <NextQuestion nextQuestion={question.nextQuestion}/>
                        <div className='answer-question bg-kiroku-date' style={{ maxWidth: 250 }}>
                            <ComponentMobile>
                                <KirokuInputDateMobile
                                    value={question.defaultAnswer}
                                    readOnly={true}
                                    name={`${question.index}-date`}
                                    onChange={(momentTime) => {
                                        let newQuestion = { ...question };
                                        newQuestion     = {
                                            ...newQuestion,
                                            defaultAnswer: typeof momentTime === 'number' ? momentTime : '',
                                        };
                                        update(newQuestion);
                                    }}
                                />
                            </ComponentMobile>
                            <ComponentWeb>
                                <KirokuInputDate
                                    inputProps={{ readOnly: true }}
                                    value={question.defaultAnswer ? moment.unix(question.defaultAnswer) : ''}
                                    timeFormat={false}
                                    dateFormat={t('dateTimeFormat.YearMonthDate')}
                                    onChange={(momentTime) => {
                                        let newQuestion = { ...question };
                                        newQuestion     = {
                                            ...newQuestion,
                                            defaultAnswer: typeof momentTime === 'object' ? momentTime.unix() : '',
                                        };
                                        update(newQuestion);
                                    }}
                                />
                            </ComponentWeb>
                        </div>
                    </KirokuCardBodyWeb>
                </KirokuCardWeb>

                <ModalEditQuestion
                    isOpenModalEditQuestion={isOpenModalEditQuestion}
                    handleAction={() => setIsOpenModalEditQuestion(!isOpenModalEditQuestion)}
                    question={question}
                    updateQuestion={(questionData) => update(questionData)}
                />

                <ModalSetLogic
                    question={question}
                    isOpen={isOpenModalName === question.index}
                    confirm={() => {
                        setIsOpenModalName(null);
                    }}
                    cancellation={() => setIsOpenModalName(null)}
                />
            </div>
        </div>
    );
}
